import { v4 as uuidv4 } from 'uuid'
import { ISEARCH_FILTER_FACETS } from '@interfaces'

const SEARCH_FILTER_FACETS: ISEARCH_FILTER_FACETS[] = [
  {
    id: uuidv4(),
    labelTx: 'search:searchFacets.all',
    type: 'all',
  },
  {
    id: uuidv4(),
    labelTx: 'search:searchFacets.collection',
    type: 'collection',
  },
  {
    id: uuidv4(),
    labelTx: 'search:searchFacets.exhibition',
    type: 'exhibition',
  },
  {
    id: uuidv4(),
    labelTx: 'search:searchFacets.object',
    type: 'object',
  },
  {
    id: uuidv4(),
    labelTx: 'search:searchFacets.people',
    type: 'people',
  },
  {
    id: uuidv4(),
    labelTx: 'search:searchFacets.event',
    type: 'event',
  },
  {
    id: uuidv4(),
    labelTx: 'search:searchFacets.publication',
    type: 'publication',
  },
  {
    id: uuidv4(),
    labelTx: 'search:searchFacets.press_release',
    type: 'press_release',
  },
  {
    id: uuidv4(),
    labelTx: 'search:searchFacets.article',
    type: 'article',
  },
]

export const AVALIABLE_SEARCH_FACETS = SEARCH_FILTER_FACETS.map(
  (facet) => facet.type
)

export default SEARCH_FILTER_FACETS
